module.exports = __webpack_public_path__ + "static/load-88ef6ca88514cd4b4e38d79226ab409b.jpg";